<template>
  <v-overlay>
    <v-list-item>  
      <v-list-item-avatar>
        <v-progress-circular indeterminate></v-progress-circular>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title>{{ title }}</v-list-item-title>
        <v-list-item-subtitle>{{ subtitle }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
  </v-overlay>
</template>

<script>
export default {
  props: {
    title: String,
    subtitle: String,
  },
};
</script>

<style>
</style>